import React from 'react'
import Layout from '../layouts/index.js'
import Contact from '../components/contact/contact.js'
import ImageSlider from '../components/hero/index'

function importAll(r) {
  return r.keys().map(r)
}

const images = importAll(
  require.context(
    '../images/check-cashing-page',
    false,
    /\.(png|jpe?g)$/ // png, jpg, jpeg
  )
)

class LunchTruckPage extends React.Component {
  render() {
    return (
      <Layout head={{ title: 'Check Cashing Envelopes & Jackets' }}>
        <section id="title">
          <div className="container">
            <div className="row">
              <div className="col text-center">
                <h1 className="heading-title">
                  Check Cashing Envelopes & Jackets
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section id="check-cashing-envelopes-jackets" className="text-center">
          <div className="container">
            <div className="row">
              <div className="col">
                <div
                  className="mb-5 "
                  style={{ maxWidth: '800px', margin: '0 auto' }}
                >
                  <p className="section-p font-weight-bold">How it works</p>
                  <div>
                    <p className="section-p">
                      Many of our grocery stores, markets and c-stores offer
                      check cashing services. We do work with many check cashing
                      / money stores too but sometimes there are no check
                      cashing stores in the area requested or they are
                      corporately owned and won’t allow advertising.
                    </p>
                    <p className="section-p">
                      The advertiser will get a mix of check cashing/money/loan
                      stores as well as grocery, c-store, markets that provide
                      check cashing services.
                    </p>
                    <p className="section-p">
                      We provide each venue 1,000 money jackets to put cash in.
                    </p>
                    <p className="section-p">
                      Check Cashing envelopes and jackets are a great “Add On”
                      to an existing storefront campaign or can be purchased
                      alone. The following images show placement examples.
                    </p>
                  </div>
                </div>
                <div className="container" style={{ maxWidth: '1800px' }}>
                  <div className="carousel-container">
                    <ImageSlider images={images} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Contact />
      </Layout>
    )
  }
}
export default LunchTruckPage
